import { Chip } from '@orbitalwatch/design';
import { Link } from 'react-router-dom';
import { Icons } from './icons';

export interface SpaceChipProps {
    /** The space's title. */
    name: string;
    /** Route of the space (its pages); omit for a static chip. */
    to?: string;
    className?: string;
}

/**
 * The current space in the top bar's context slot (boards: an accent outline chip with the book glyph): a library
 * `Chip`, wrapped in a router link when `to` is set (`ds.css` "space chip").
 */
export function SpaceChip(props: SpaceChipProps) {
    const chip = (
        <Chip tone="accent" size="sm" icon={<Icons.book size={12} />} className="ark-space-chip-label" title={props.name}>
            {props.name}
        </Chip>
    );
    if (!props.to) return <span className={['ark-space-chip', props.className].filter(Boolean).join(' ')}>{chip}</span>;
    return (
        <Link to={props.to} className={['ark-space-chip', props.className].filter(Boolean).join(' ')} aria-label={`Space: ${props.name}`}>
            {chip}
        </Link>
    );
}
